import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
import styled from 'styled-components';
import { getLocationWorkbenchBaseRoute } from 'utils/RouteHelper';

const StyledWorkbenchLink = styled.a`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    color: var(--text-link);
    font-size: 1.4rem;
    text-decoration: none;
    transition: color 0.2s ease, text-decoration 0.2s ease;

    &:hover {
        color: var(--text-link-hover);
        text-decoration: underline;
    }
`;

const WorkbenchLinkIcon = styled(FontAwesomeIcon)`
    font-size: 1.2rem;
    margin-left: 0.4rem;
`;

type WorkbenchLinkComponentProps = {
    locationId: string;
};

export function WorkbenchLink({ locationId }: WorkbenchLinkComponentProps) {
    const workbenchLink = useMemo(() => getLocationWorkbenchBaseRoute(locationId), [
        locationId,
    ]);

    return (
        <StyledWorkbenchLink
            href={workbenchLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Go to Workbench to view all alerts"
        >
            Go to Workbench
            <WorkbenchLinkIcon icon={faExternalLinkAlt} aria-hidden="true" />
        </StyledWorkbenchLink>
    );
}
